/*
 * /document-signer — сборка страницы: вкладки, прямые ссылки, перетаскивание.
 *
 * Вкладка по умолчанию — «Проверить»: за ней приходят из поиска (открыть .sig,
 * проверить подпись). «Подписать» открывается ссылкой #sign — её кладём в
 * README архива и в подсказку получателю.
 *
 * Проверку ведёт ES-модуль sigcheck/app.js (window.__SC_APP); он грузится
 * позже этих тегов — файлы, брошенные до него, ждут его в очереди.
 */
(function (root) {
    'use strict';
    var DS = root.DS;
    if (!DS || !root.PKI || !root.PKI.Cms) return;

    // Файлы во вкладку «Проверить»: модуль проверки может ещё грузиться.
    var verifyQueue = [];
    function toVerify(files, source) {
        var app = root.__SC_APP;
        if (app && app.addFiles) { app.addFiles(files, source); return; }
        verifyQueue.push([files, source]);
    }
    root.addEventListener('sc-app-ready', function () {
        var q = verifyQueue; verifyQueue = [];
        q.forEach(function (x) { root.__SC_APP.addFiles(x[0], x[1]); });
    });
    /* «Проверить как получатель»: из вкладки «Подписать» — во вкладку
       «Проверить» с только что подписанными файлами. */
    DS.openVerify = function (files, source) {
        setTab('verify', true);
        if (root.__SC_APP && root.__SC_APP.reset) root.__SC_APP.reset();
        toVerify(files, source || 'from_sign');
    };

    function setTab(tab, fromUser) {
        var sign = tab === 'sign';
        var apply = function () {
            ['verify', 'sign'].forEach(function (k) {
                var btn = DS.$('dsTab-' + k), panel = DS.$(k === 'sign' ? 'dsSign' : 'dsVerify');
                var on = (k === 'sign') === sign;
                if (btn) { btn.classList.toggle('on', on); btn.setAttribute('aria-selected', on ? 'true' : 'false'); btn.tabIndex = on ? 0 : -1; }
                DS.show(panel, on);
            });
            var rootEl = DS.$('dsApp');
            if (rootEl) rootEl.setAttribute('data-tab', sign ? 'sign' : 'verify');
        };
        if (fromUser && root.__viewTransition) root.__viewTransition(apply); else apply();
        if (fromUser) {
            // hash без прыжка страницы: replaceState, а не location.hash.
            try { history.replaceState(null, '', location.pathname + location.search + (sign ? '#sign' : '')); } catch (e) { /* noop */ }
            DS.ae('tab', { tab: sign ? 'sign' : 'verify' });
        }
    }

    function init(cfg) {
        DS.setStrings(cfg && cfg.str);
        DS.sign.init();
        ['verify', 'sign'].forEach(function (k) {
            var b = DS.$('dsTab-' + k);
            if (b) b.addEventListener('click', function () { setTab(k, true); });
        });
        // Стрелки на вкладках — как у настоящего tablist.
        var list = DS.$('dsTabs');
        if (list) list.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
            var cur = DS.$('dsApp').getAttribute('data-tab') === 'sign' ? 'sign' : 'verify';
            var next = cur === 'sign' ? 'verify' : 'sign';
            setTab(next, true);
            var b = DS.$('dsTab-' + next); if (b) b.focus();
            e.preventDefault();
        });
        setTab(/^#sign\b/.test(location.hash) ? 'sign' : 'verify', false);

        // Файлы, брошенные на тул мимо зоны загрузки, — туда же, куда и в зону.
        var app = DS.$('dsApp');
        if (app) {
            var depth = 0;
            app.addEventListener('dragenter', function (e) { if (hasFiles(e)) { depth++; app.classList.add('ds-drag'); } });
            app.addEventListener('dragleave', function () { depth = Math.max(0, depth - 1); if (!depth) app.classList.remove('ds-drag'); });
            app.addEventListener('dragover', function (e) { if (hasFiles(e)) e.preventDefault(); });
            app.addEventListener('drop', function (e) {
                depth = 0; app.classList.remove('ds-drag');
                if (!hasFiles(e) || e.defaultPrevented) return;
                if (e.target && e.target.closest && e.target.closest('.tool-uploader')) return;   // зона разберётся сама
                e.preventDefault();
                var files = e.dataTransfer.files;
                if (app.getAttribute('data-tab') === 'sign') DS.sign.addFiles(files); else toVerify(files, 'drop_app');
            });
        }
        DS.stage('ready');
    }
    function hasFiles(e) {
        var dt = e.dataTransfer;
        if (!dt) return false;
        var types = dt.types || [];
        for (var i = 0; i < types.length; i++) if (types[i] === 'Files') return true;
        return false;
    }

    DS.init = init;
})(typeof window !== 'undefined' ? window : globalThis);
